<template>
    <div id="Surveyout">
        <img
            src="@/assets/images/bg.png"
            alt=""
            style="width:100%;"
        >
        <div id="Survey">
            <h1
                style="text-align:center"
                v-if="ispush"
            >{{config.title}}</h1>
            <div
                class="memo"
                v-html="config.memo"
                v-if="ispush"
            ></div>
            <el-form
                :model="form"
                ref="form"
                class="formarea"
                :rules="ruleForm"
                v-if="ispush && type=='2'"
            >
                <div
                    class="d-main"
                    v-for="(item,index) in config.data"
                    :key="index"
                    :id="index"
                >
                    <div
                        class='d-section  d-noimg'
                        v-if="item.type=='1'"
                    >
                        <el-form-item
                            :label="item.title+'(单选题)'"
                            prop="value"
                            style="font-size:24px"
                            :class="item.must?'is-required':''"
                        >
                            <div
                                style="color:red;font-size:14px;"
                                v-if="item.must&&item.selected"
                            >请选择</div>
                            <el-radio-group
                                v-model="item.answerid"
                                @change="radioChange(item,index)"
                            >
                                <el-radio
                                    v-for="(items,indexs) in item.opData"
                                    :key="indexs"
                                    :label="items.id"
                                    v-model="items.answerid"
                                >{{items.name}}<el-input
                                        v-if="items.haveBlanks&&item.answerid==items.id"
                                        placeholder="请回答问题"
                                        v-model="items.fillValue"
                                    ></el-input>
                                    <span
                                        style="color:red;font-size:14px;"
                                        v-if="items.must&&items.selected"
                                    >请填写内容</span> </el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                    <div
                        class='d-noimg'
                        v-if="item.type=='2'"
                    >
                        <el-form-item
                            :label="item.title+'(多选题)'"
                            :prop="item.value"
                            style="font-size:24px"
                            :class="item.must?'is-required':''"
                        >
                            <div
                                style="color:red;font-size:14px;"
                                v-if="item.must&&item.selected"
                            >请选择</div>
                            <el-checkbox-group v-model="item.checkList">
                                <el-checkbox
                                    :label="items.id"
                                    v-for="(items,indexs) in item.opData"
                                    :key="indexs"
                                    @change="box(item,items,index)"
                                >{{items.name}}<el-input
                                        v-if="items.haveBlanks&&items.answerid==items.id"
                                        placeholder="请回答问题"
                                        v-model="items.fillValue"
                                    ></el-input>
                                    <span
                                        style="color:red;font-size:14px;"
                                        v-if="items.must&&items.selected"
                                    >请填写内容</span> </el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                    </div>
                    <div
                        class='d-noimg'
                        v-if="item.type=='3'"
                    >
                        <el-form-item
                            :label="item.title+'(填空题)'"
                            :prop="item.value"
                            style="font-size:24px"
                            :class="item.must?'is-required':''"
                        >
                            <div
                                style="color:red;font-size:14px;"
                                v-if="item.must&&item.selected"
                            >请填写内容</div>
                            <el-input
                                type="textarea"
                                placeholder="请输入"
                                v-model.trim="item.fillValue"
                            ></el-input>
                        </el-form-item>
                    </div>
                    <div
                        class="a-i-item"
                        v-if="item.type=='5'"
                    >
                        <div
                            class="i-items"
                            style="position:relative;overflow:hidden;"
                        >
                            <div class="i-t"><span
                                    v-if="item.must"
                                    class="starm"
                                >*</span>{{item.title}}(评价题)</div>
                            <div
                                style="color:red;font-size:14px;"
                                v-if="item.must&&item.selected"
                            >请评价</div>
                            <ul class="star">
                                <li
                                    v-for="(itemClass,indexs) in item.list"
                                    class="star-item"
                                    @click="stars(indexs,index)"
                                    :key="indexs"
                                >
                                    <img :src="item.num>indexs?on:off" />
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div
                        class="d-noimg"
                        v-if="item.type=='4'"
                    >
                        <el-form-item
                            :label="item.title+'(多项填空题)'"
                            prop="value"
                            style="font-size:24px"
                            :class="item.must?'is-required':''"
                        >
                            <el-col
                                :span="12"
                                v-for="(items,indexs) in item.blanksTitles"
                                :key="indexs"
                                style="display:flex;align-items:center;"
                            >
                                <el-form-item :label="items.name">
                                    <el-input
                                        type="text"
                                        placeholder="请回答问题"
                                        v-model.trim="items.fillValue"
                                    ></el-input>
                                </el-form-item>
                                <span
                                    style="color:red;font-size:14px;margin-left:10px;"
                                    v-if="items.must&&items.selected"
                                >请填写内容</span>
                            </el-col>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
            <el-form
                :model="form"
                ref="form"
                class="formarea"
                :rules="ruleForm"
                v-if="ispush && type=='1'"
            >
                <el-tabs
                    class="main_tabs"
                    v-model.trim="activeName"
                    type="border-card"
                >
                    <div
                        v-for="(item,index) in config.data"
                        :key="index"
                        :id="index"
                    >
                        <el-tab-pane :name="String(index)">
                            <div
                                class='d-section  d-noimg'
                                v-if="item.type=='1'"
                            >
                                <el-form-item
                                    :label="item.title+'(单选题)'"
                                    prop="value"
                                    style="font-size:24px"
                                    :class="item.must?'is-required':''"
                                >
                                    <div
                                        style="color:red;font-size:14px;"
                                        v-if="item.must&&item.selected"
                                    >请选择</div>
                                    <el-radio-group v-model="item.answerid">
                                        <el-radio
                                            v-for="(items,indexs) in item.opData"
                                            :key="indexs"
                                            :label="items.id"
                                            v-model="items.answerid"
                                        >{{items.name}}<el-input
                                                v-if="items.haveBlanks&&item.answerid==items.id"
                                                placeholder="请回答问题"
                                                v-model="items.fillValue"
                                            ></el-input>
                                            <span
                                                style="color:red;font-size:14px;"
                                                v-if="items.must&&items.selected"
                                            >请填写内容</span> </el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                            <div
                                class='d-noimg'
                                v-if="item.type=='2'"
                            >
                                <el-form-item
                                    :label="item.title+'(多选题)'"
                                    :prop="item.value"
                                    style="font-size:24px"
                                    :class="item.must?'is-required':''"
                                >
                                    <div
                                        style="color:red;font-size:14px;"
                                        v-if="item.must&&item.selected"
                                    >请选择</div>
                                    <el-checkbox-group v-model="item.checkList">
                                        <el-checkbox
                                            :label="items.id"
                                            v-for="(items,indexs) in item.opData"
                                            :key="indexs"
                                            @change="box(item,items,index)"
                                        >{{items.name}}<el-input
                                                v-if="items.haveBlanks&&items.answerid==items.id"
                                                placeholder="请回答问题"
                                                v-model="items.fillValue"
                                            ></el-input>
                                            <span
                                                style="color:red;font-size:14px;"
                                                v-if="items.must&&items.selected"
                                            >请填写内容</span> </el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                            </div>
                            <div
                                class='d-noimg'
                                v-if="item.type=='3'"
                                :class="item.must?'is-required':''"
                            >
                                <el-form-item
                                    :label="item.title+'(填空题)'"
                                    :prop="item.value"
                                    style="font-size:24px"
                                >
                                    <div
                                        style="color:red;font-size:14px;"
                                        v-if="item.must&&item.selected"
                                    >请填写内容</div>
                                    <el-input
                                        type="textarea"
                                        placeholder="请输入"
                                        v-model.trim="item.fillValue"
                                    ></el-input>
                                </el-form-item>
                            </div>
                            <div
                                class="a-i-item"
                                v-if="item.type=='5'"
                            >
                                <div
                                    class="i-items"
                                    style="position:relative;overflow:hidden;"
                                >
                                    <div class="i-t"><span
                                            v-if="item.must"
                                            class="starm"
                                        >*</span>{{item.title}}(评价题)</div>
                                    <div
                                        style="color:red;font-size:14px;"
                                        v-if="item.must&&item.selected"
                                    >请评价</div>
                                    <ul class="star">
                                        <li
                                            v-for="(itemClass,indexs) in item.list"
                                            class="star-item"
                                            @click="stars(indexs,index)"
                                            :key="indexs"
                                        >
                                            <img :src="item.num>indexs?on:off" />
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div
                                class="d-noimg"
                                v-if="item.type=='4'"
                            >
                                <el-form-item
                                    :label="item.title+'(多项填空题)'"
                                    prop="value"
                                    style="font-size:24px"
                                >
                                    <el-col
                                        :span="12"
                                        v-for="(items,indexs) in item.blanksTitles"
                                        :key="indexs"
                                        style="display:flex;align-items:center;"
                                    >
                                        <el-form-item :label="items.name">
                                            <el-input
                                                type="text"
                                                placeholder="请回答问题"
                                                v-model.trim="items.fillValue"
                                            ></el-input>
                                        </el-form-item>
                                        <span
                                            style="color:red;font-size:14px;margin-left:10px;"
                                            v-if="items.must&&items.selected"
                                        >请填写内容</span>
                                    </el-col>
                                </el-form-item>
                            </div>
                            <el-row style="text-align:center;">
                                <el-button
                                    v-if="activeName !='0'"
                                    @click="prev(item)"
                                >上一步</el-button>
                                <el-button
                                    type="primary"
                                    @click="next(item)"
                                    v-if="activeName !=config.data.length-1"
                                >下一步</el-button>
                                <el-button
                                    type="primary"
                                    @click="submitForm"
                                    v-if="activeName ==config.data.length-1 && btnshow"
                                >提交</el-button>
                            </el-row>
                        </el-tab-pane>

                    </div>

                </el-tabs>
            </el-form>
            <div
                class='btn'
                v-if="ispush && type=='2' && btnshow"
            >
                <div @click="submitForm">提交</div>
            </div>
            <div
                v-if="!ispush"
                style="font-size:24px;text-align:center;"
            >
                {{msg}}
            </div>
        </div>
    </div>
</template>
<script>
import on from '@/assets/images/icon/star_on.png'
import off from '@/assets/images/icon/star_off.png'
export default {
    name: "Survey",
    data () {
        return {
            ruleForm: {},
            config: [],
            configBackUP: [],
            dictionary: {},
            activeName: 0,
            type: 1,
            msg: "",
            btnshow: true,
            typeone: {
                index: null,
                items: null,
            },
            form: {

            },
            istype: true,
            score: 0,
            on: on,
            off: off,
            ispush: false,
        };
    },
    async mounted () {
        let me = this;
        // let main = document.getElementById("Survey");
        // let height=me.$global.height-240;
        // main.style.height = height + "px"
        if (this.$route.query) {
            const id = this.$route.query.id;
            const uuid = localStorage.getItem('deviceId');
            if (this.$route.query.showId) {
                this.btnshow = false;
                this.checkispush(id, uuid)
            } else {
                this.checkQuestionnatire(id, uuid);
            }
        }
    },
    methods: {
        insertblur () {
            setTimeout(function () {
                var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
            }, 100);
        },
        prev (item) {
            let index = this.getIndex(this.config, item);
            this.istype = true;
            if (this.config.data[Number(index) - 1].type == '2') {
                this.config.data[Number(index) - 1].opData.forEach(i => {
                    if (i.id == this.config.data[Number(index) - 1].answerid) {
                        this.typeone.items = i;
                    }
                })
            }
            let q = this.getIndex(this.configBackUP, item);
            this.getSkip(q, (Number(index) - 1))
            this.activeName = String(Number(index) - 1);
        },
        next (item) {
            let me = this;
            let ischeck = false, ischecks = false;
            if (item.type == '1') {
                if (item.must && !item.answerid) {
                    item.selected = true;
                } else {
                    item.selected = false;
                }
                item.opData.forEach((items) => {
                    if (items.must && !items.fillValue && item.answerid == items.id) {
                        items.selected = true;
                        ischecks = items.selected;
                    }
                })
            }
            if (item.type == '2') {
                if (item.must && item.checkList.length == 0) {
                    item.selected = true;
                } else {
                    item.selected = false;
                }

                item.checkList.forEach(items => {
                    item.opData.forEach(ite => {
                        if (ite.must && !ite.fillValue && items == ite.id) {
                            ite.selected = true;
                            ischecks = ite.selected;
                        } else {
                            ite.selected = false;
                            //    ischecks=ite.selected;
                        }
                    })
                })
            }
            if (item.type == '3') {
                if (item.must && !item.fillValue) {
                    item.selected = true;

                } else {
                    item.selected = false;
                }
            }
            if (item.type == '4') {
                item.blanksTitles.forEach(items => {
                    if (items.must && !items.fillValue) {
                        items.selected = true;
                        ischecks = items.selected;
                    } else {
                        items.selected = false;
                        //    ischecks=items.selected;
                    }
                })
            }
            if (item.type == '5') {
                if (item.must && item.num == '0') {
                    item.selected = true;
                } else {
                    item.selected = false;
                }
            }
            ischeck = item.selected;
            if (!ischeck && !ischecks) {
                let index = this.getIndex(this.config, item);
                if (item.type == '1' && item.answerid) {
                    this.radioChange(item, index);
                    this.activeName = String(Number(index) + 1);
                } else {
                    this.activeName = String(Number(index) + 1);
                }

                if (item.type == '2' && item.checkList.length > 0) {
                    this.istype = false;
                    this.box(item, this.typeone.items, index);
                    this.activeName = String(Number(index) + 1);
                } else {
                    this.activeName = String(Number(index) + 1);
                }
            }

        },
        radioChange (val, indexs) {
            let me = this;
            let q = me.getIndex(me.configBackUP, val);
            if (val.type == '1' || val.type == '2') {
                for (var i = 0; i < val.opData.length; i++) {
                    if (val.opData[i].id == val.answerid) {
                        val.opData[i].answerid = val.opData[i].id;
                        me.$set(val.opData[i], 'answerid', Number(val.answerid))
                        if (val.opData[i].nextSubjectId) {
                            me.backup(me.configBackUP, me.config);
                            me.go(val.opData[i].nextSubjectId, indexs, q)
                        } else {
                            me.getSkip(q, indexs)
                            return false;
                        }
                    }
                }

            }
        },
        go (val, indexs, q) {
            let me = this;
            let back = false;
            me.config.data.forEach((item, index) => {
                if (item.id == val) {
                    back = true;
                    let num = Number(index) - Number(indexs) - 1;
                    me.config.data.splice(indexs + 1, num);
                }
            })
            if (!back) {
                me.getSkip(q, indexs);
                me.go(val, indexs, q);
            }
        },
        backup (target, come) {
            let me = this;
            for (var i in target.data) {
                for (var item of come.data) {
                    if (item.type == '1' || item.type == '2') {
                        if (target.data[i].id == item.id) {
                            me.$set(target.data, i, JSON.parse(JSON.stringify(item)))
                            break;
                        }
                    }
                }
            }
        },
        getIndex (data, obj) {
            let res;
            let me = this;
            data.data.forEach((i, n) => {
                if (i.id == obj.id) {
                    res = n
                }
            })
            return res
        },
        getSkip (q, indexs) {
            let me = this;
            let obj = JSON.parse(JSON.stringify(me.configBackUP));
            me.config.data.splice(Number(indexs) + 1, me.config.data.length);
            obj.data.splice(0, Number(q) + 1);
            me.config.data = me.config.data.concat(obj.data);
        },
        box (obj, val, indexs) {
            let me = this;
            let q = me.getIndex(me.configBackUP, obj);
            me.backup(me.configBackUP, me.config);
            if (me.type == '1') {
                me.typeone = {
                    index: indexs,
                    items: val
                }
            }
            if (obj.checkList.indexOf(val.id) != '-1') {
                val.answerid = val.id;
                this.$set(val, 'answerid', val.id);
                if (!me.istype) {

                    if (val.nextSubjectId) {
                        me.backup(me.configBackUP, me.config);
                        me.go(val.nextSubjectId, indexs)
                    } else {
                        me.getSkip(q, indexs)
                        return false;

                    }
                }
            } else {
                val.answerid = null;
                this.$set(val, 'answerid', null);
            }
        },
        async checkQuestionnatire (id, uuid) {
            let me = this, param = {
                id: id
            }
            let res = await me.$userService.checkQuestionnatire(param);
            if (res && res["success"]) {
                if (res.content.success) {
                    me.checkispush(id, uuid)
                } else {
                    me.ispush = false;
                    me.msg = res.content.msg

                }
            }
        },
        async checkispush (id, uuid) {
            let me = this;
            let param = {
                questionId: id,
                deviceId: uuid,
            }
            let res = await me.$userService.checkIsPushQuestion(param);
            if (res && res["success"]) {
                if (res.content) {
                    me.ispush = false;
                    me.msg = '您已经提交过此评价'
                } else {
                    me.ispush = true;
                    me.getDetail(id)

                }
            }
        },
        async getDetail (id) {
            let me = this, param = {
                id: id
            };
            let res = await me.$userService.getDetail(param);
            if (res && res["success"]) {
                if (res.content.onlyOne) {
                    me.type = '1'
                    me.istype = true
                } else {
                    me.type = '2'
                    me.istype = false
                }
                res.content.data.forEach((item, index) => {
                    if (item.must) {
                        item.selected = false;
                    }
                    if (item.type == '1' || item.type == '2') {
                        me.$set(item, 'answerid', null)
                        if (item.opData) {
                            item.opData.forEach((items) => {
                                if (items.must) {
                                    items.selected = false
                                }
                                me.$set(items, 'fillValue', null)
                                me.$set(items, 'answerid', "")
                            })
                        }
                    }
                    if (item.type == '2') {
                        me.$set(item, 'checkList', [])
                    }
                    if (item.type == '3') {
                        me.$set(item, 'fillValue', null)
                    }
                    if (item.type == '4') {
                        if (item.blanksTitles) {
                            item.blanksTitles = JSON.parse(item.blanksTitles);
                        }
                        if (item.mustFillNum) {
                            item.mustFillNum = item.mustFillNum.split(',');
                        }
                        item.blanksTitles.forEach((items, index) => {
                            if (item.blanksTitles[item.mustFillNum[index]]) {
                                item.blanksTitles[item.mustFillNum[index]].must = true;
                                item.blanksTitles[item.mustFillNum[index]].selected = false;
                            }
                            me.$set(items, 'fillValue', null)
                        })
                    }
                    if (item.type == '5') {
                        item.score = 0,
                            item.fraction = 0,
                            item.num = 0,
                            item.list = [0, 1, 2, 3, 4];
                    }
                })
                me.config = res.content;
                me.configBackUP = JSON.parse(JSON.stringify(res.content))
            }
        },

        gettop (index) {
            let id = document.getElementById(index);
            document.getElementById("Survey").scrollTop = id.offsetTop - 20;
            throw new Error("");
        },
        stars: function (indexs, index) {
            this.config.data[index].num = indexs + 1;
        },
        async submitForm () {
            let me = this;
            let flag = navigator.userAgent.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            let param = {
                questionId: me.config.id,
                deviceId: localStorage.getItem('deviceId'),
                deviceType: flag ? '2' : '1',
                answerDetail: {
                }
            };
            let optionData = {}, can = false;
            try {
                me.config.data.forEach((item, index) => {
                    if (item.type == '1') {
                        let opdata = {
                            optionData: {}
                        };
                        if (item.must && !item.answerid) {
                            item.selected = true;
                            me.gettop(index);
                        } else {
                            item.selected = false;
                        }
                        item.opData.forEach((items) => {
                            if (items.must && !items.fillValue && item.answerid == items.id) {
                                items.selected = true;
                                me.gettop(index);
                            }
                            if (item.must && items.must && item.answerid == items.id) {
                                opdata.optionData[item.answerid] = items.fillValue;
                            }
                            if (item.must && !items.must && item.answerid == items.id) {
                                opdata.optionData[item.answerid] = null;
                            }
                            if (!item.must) {
                                opdata.optionData[item.answerid] = items.fillValue;
                            }

                        })
                        if (item.opData.length == '0') {
                            opdata.optionData[item.answerid] = null;
                        }
                        optionData[item.id] = opdata;
                    }
                    if (item.type == '2') {
                        let opdatas = {
                            optionData: {}
                        };
                        if (item.must && item.checkList.length == 0) {
                            item.selected = true;
                            me.gettop(index);
                        } else {
                            item.selected = false;
                        }
                        item.checkList.forEach(items => {
                            item.opData.forEach(ite => {
                                if (ite.must && !ite.fillValue && items == ite.id) {
                                    ite.selected = true;
                                    me.gettop(index);
                                } else {
                                    ite.selected = false;
                                }
                                if (items == ite.id) {
                                    opdatas.optionData[items] = ite.fillValue;
                                }
                            })
                        })
                        optionData[item.id] = opdatas;
                    }
                    if (item.type == '3') {
                        let blankd = {
                            blanksDetail: null
                        };
                        if (item.must && !item.fillValue) {
                            item.selected = true;
                            me.gettop(index);
                        } else {
                            item.selected = false;
                        }
                        if (item.fillValue) {
                            blankd.blanksDetail = [];
                            blankd.blanksDetail.push(item.fillValue);
                        }

                        optionData[item.id] = blankd
                    }
                    if (item.type == '4') {
                        let blankds = {
                            blanksDetail: []
                        };
                        item.blanksTitles.forEach(items => {
                            if (items.must && !items.fillValue) {
                                items.selected = true;
                                me.gettop(index);
                            } else {
                                items.selected = false;
                            }
                            if (items.fillValue) {
                                blankds.blanksDetail.push(items.fillValue);
                            } else {
                                blankds.blanksDetail.push("");
                            }
                        })
                        let arr = item.blanksTitles.find((i) => {
                            return i.fillValue
                        })
                        if (arr == undefined) {
                            blankds.blanksDetail = null;
                        }
                        optionData[item.id] = blankds
                    }
                    if (item.type == '5') {
                        let score = {};
                        if (item.must && item.num == '0') {
                            item.selected = true;
                            me.gettop(index);
                        } else {
                            item.selected = false;
                        }
                        if (item.num && item.num != '0') {
                            score.score = item.num
                            optionData[item.id] = score
                        }
                    }
                    if (index == me.config.data.length - 1) {
                        can = true;
                    }
                })
            } catch (e) {
                return true;
            }
            if (can) {
                param.answerDetail = optionData;
                let res = await me.$userService.pushQuestion(param);
                if (res && res["success"]) {
                    me.$router.replace({
                        name: "Surveys", query: {
                            memo: JSON.stringify(me.config.questionDeclare)
                        }
                    });
                }
            }
        },
    }
};
</script>
<style lang="scss">
#app{
    background:#fff !important;
}
#Surveyout{
    background: #3660E6;
    margin: 0 auto;
    width: 880px;
    padding-bottom: 40px;
}
#Survey{
   
    .el-tabs.main_tabs .el-tabs__header{
        height:0px;padding:0px;
    }
    .starm{color:#F56C6C;display: inline-block;margin-right: 5px;}
    padding:20px 50px 50px 50px;
    box-sizing: border-box;
    
    background: #fff;
    width: 800px;
    margin: 0 auto;
    overflow: auto;
    
    
    .memo{padding:15px 0;font-size: 16px;}
    .d-main{
        border-bottom:1px solid #E7E9EC;
    }
    .el-radio__label .el-input,.el-checkbox__label .el-input{margin-left:15px;}
    .el-checkbox-group{
        display: flex;display:-webkit-flex;flex-direction: column;
    }
    .el-checkbox{
        margin: 5px 0;
    }
    .el-radio:first-child{margin-top:10px;} 
    .el-form-item{
        margin-bottom:5px;
    }
    .el-textarea{    margin-bottom: 10px;}
    .el-col{padding:0 10px;
            .el-form-item{
                display: flex;margin:10px 0;
            }
            .el-form-item__label{
            float: left;
        }
    }
    .d-section{display: flex;}
    .el-form-item__label{float:none;
       font-size: 16px;font-weight: bold; 
    }
    .el-radio{display:flex;align-items: center;margin: 20px 0;}
    .el-radio-group
    div{
      font-size: 16px;
    }
    .a-i-item{
               padding:0px 10px; 
                box-sizing: border-box; margin-bottom:10px;
                .i-items{
                    margin:10px 0;font-weight: bold;
                    font-size: 16px;border-bottom: 1px dashed #E7E9EC;
                    div{
                        font-size: 16px;
                    }
                    span{
                        color: #FF6600;position: relative;left:3px;
                    }
                    textarea{
                        margin:5px 0;font-size: 16px;padding:5px;box-sizing: border-box;
                        border:none;outline: none;width:100%;min-height:40px;border:1px solid #E7E9EC;border-radius: 5px;
                    }
                    .star{
                        margin:10px 0;
                       
                    }
                      ul{
                    padding:0px;margin:0px;
                    li{
                        margin:0 10px;width: 25px;height:25px;
                        img{
                            width: 100%;height:100%;
                        }
                    }
                    li:first-child{
                        margin:0px;
                    }
                    }
                }
                .i-items:last-child{
                    border-bottom:none;
                }
              
            }
    .star{
            font-size: 0;
            }
            .star-item{
            display: inline-block;
            background-repeat: no-repeat;
            width: .6rem;
            height: .6rem;
            margin-left: .27rem;
            background-size: 100%;
            }
           
    .btn{
            margin-top:40px;padding: 0 10px;box-sizing: border-box;
      div{
          text-align: center;font-size: 16px;height:40px;line-height: 40px;color: #fff;background: #3295F9;border-radius: 10px;width:120px;margin: 0 auto;cursor: pointer;
      }
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Survey/Survey.vue